import React from 'react';
import { useAuth } from '../../context/AuthContext';
import ManagerDashboard from './ManagerDashboard';
import AgentDashboard from './AgentDashboard';

const Dashboard = () => {
  const { isManager, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Route to appropriate dashboard based on role
  return isManager ? <ManagerDashboard /> : <AgentDashboard />;
};

export default Dashboard;
